export default __webpack_public_path__ + "static/media/qrDummy.6dba2743.png";